<template>
  <div class="listcard-page">
    <div class="desktop" v-if="display === 'Desktop'">
      <div class="loadding_content" v-if="isLoadding">
        <v-container
          fill-height
          :style="'height: ' + (heightDisplay - 100) + 'px;'"
        >
          <v-row align="center" justify="center">
            <v-col class="text-center">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <h1 style="font-size: 70px">
                    <span style="color: #3f44a3">Kan</span>
                    <span style="color: #4a98b2">Pramool</span>
                  </h1>
                  <h3><b>กำลังเตรียมข้อมูล</b></h3>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col class="text-center" lg="4" md="4">
                  <v-progress-linear
                    color="#F8F364"
                    indeterminate
                    rounded
                    height="8"
                  >
                  </v-progress-linear>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="data_content" v-else>
        <v-lazy
          v-model="isActive"
          :options="{
            threshold: 0.5,
          }"
          min-height="200"
          transition="fade-transition"
        >
          <div>
            <APPBAR></APPBAR>
            <v-card class="tab-top">
              <v-container>
                <v-row>
                  <v-col class="pt-2 pb-2" lg="4" md="4">
                    <v-autocomplete
                      :menu-props="{ closeOnContentClick: true }"
                      @change="clearKeyboard()"
                      :disabled="isLoaddingData"
                      v-model="form.province"
                      :items="provinces"
                      hide-details
                      append-icon="mdi-magnify"
                      outlined
                      chips
                      dense
                      small-chips
                      clearable
                      hide-selected
                      label="ค้นหา"
                      item-text="name_th"
                      item-value="id"
                      multiple
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          close
                          small
                          class="chip--select-multi"
                          @click:close="removeProvince(data.item)"
                        >
                          {{ data.item.name_th }}
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item">
                          </v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content v-html="data.item.name_th">
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col class="pt-2 pb-2">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :disabled="isLoaddingData"
                      :close-on-content-click="false"
                      :return-value.sync="date1"
                      transition="scale-transition"
                      min-width="290px"
                      max-width="290px"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          v-model="dateFormatted1"
                          hide-details
                          v-on="on"
                          outlined
                          dense
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date1"
                        @input="$refs.menu1.save(date1)"
                        scrollable
                        locale="TH-th"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="pt-2 pb-2">
                    <v-menu
                      ref="menu2"
                      :disabled="isLoaddingData"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :return-value.sync="date2"
                      transition="scale-transition"
                      min-width="290px"
                      max-width="290px"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          v-model="dateFormatted2"
                          hide-details
                          v-on="on"
                          outlined
                          dense
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date2"
                        @input="$refs.menu2.save(date2)"
                        scrollable
                        locale="TH-th"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="pt-2 pb-2">
                    <v-select
                      ref="keyboard"
                      :disabled="isLoaddingData"
                      outlined
                      dense
                      v-model="form.jobtype"
                      :items="jobtypes"
                      item-text="job_type_name"
                      item-value="job_type_id"
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col class="pt-2 pb-2">
                    <v-btn
                      block
                      color="#4347B3"
                      style="padding: 5%"
                      @click="searchFn(true)"
                      :disabled="isLoaddingData"
                    >
                      <h4 style="font-size: 18px; color: white">ค้นหา</h4>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-container v-if="isLoaddingData" class="skeleton_content">
              <v-row>
                <v-col lg="2" md="2" class="text-center"></v-col>
                <v-col lg="2" md="2" class="text-center">
                  <v-row justify="center" align="center">
                    <v-col class="text-left">
                      <v-row justify="center" align="center">
                        <v-col class="pb-0 mb-0">
                          <span
                            style="
                              color: #4347b3;
                              font-weight: bold;
                              font-size: 17px;
                            "
                          >
                            ประเภทประกาศ</span
                          >
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pb-0 mb-0">
                          <v-radio-group
                            class="mt-0"
                            v-model="announcement_type"
                            :disabled="isLoaddingData"
                          >
                            <v-radio label="ร่าง ToR" value="tor"></v-radio>
                            <v-radio label="เชิญชวน" value="invite"></v-radio>
                            <v-radio
                              v-if="false"
                              label="ผู้ชนะ"
                              value="ebidding"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pb-0 mb-0">
                          <span
                            style="
                              color: #4347b3;
                              font-weight: bold;
                              font-size: 17px;
                            "
                          >
                            วันที่ยื่นซอง</span
                          >
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pt-0 mt-0 pb-0">
                          <v-radio-group
                            class="mt-0"
                            v-model="submission_date"
                            :disabled="isLoaddingData"
                          >
                            <v-radio
                              label="เรียงจากมากไปน้อย"
                              value="DESC"
                            ></v-radio>
                            <v-radio
                              label="เรียงจากน้อยไปมาก"
                              value="ASC"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pb-0 mb-0 pt-0">
                          <span
                            style="
                              color: #4347b3;
                              font-weight: bold;
                              font-size: 17px;
                            "
                            >ราคากลาง</span
                          >
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pt-0 mt-0">
                          <v-radio-group
                            class="mt-0"
                            v-model="standard_price"
                            :disabled="isLoaddingData"
                          >
                            <v-radio
                              label="เรียงจากมากไปน้อย"
                              value="DESC"
                            ></v-radio>
                            <v-radio
                              label="เรียงจากน้อยไปมาก"
                              value="ASC"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-left mt-6 pb-1">
                      <span
                        style="
                          font-size: 22px;
                          color: #4347b3;
                          font-weight: bold;
                        "
                      >
                        โครงการเเนะนำ
                      </span>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="text-center">
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col lg="2" md="2" class="text-center"></v-col>
              </v-row>
            </v-container>
            <v-container v-else>
              <v-row justify="center" align="start">
                <v-col lg="2" md="2" class="text-center"></v-col>
                <v-col md="3" lg="3" class="data_recommend text-center">
                  <v-row justify="center" align="center">
                    <v-col class="text-left">
                      <v-row justify="center" align="center">
                        <v-col class="pb-0 mb-0">
                          <span
                            style="
                              color: #4347b3;
                              font-weight: bold;
                              font-size: 17px;
                            "
                          >
                            ประเภทประกาศ</span
                          >
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pb-0 mb-0 pt-0">
                          <v-radio-group
                            class="mt-0"
                            v-model="announcement_type"
                            :disabled="isLoaddingData"
                          >
                            <v-radio label="ร่าง ToR" value="tor"></v-radio>
                            <v-radio label="เชิญชวน" value="invite"></v-radio>
                            <v-radio
                              v-if="false"
                              label="ผู้ชนะ"
                              value="ebidding"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pb-0 mb-0">
                          <span
                            style="
                              color: #4347b3;
                              font-weight: bold;
                              font-size: 17px;
                            "
                            >วันที่ยื่นซอง</span
                          >
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pt-0 mt-0 pb-0">
                          <v-radio-group
                            class="mt-0"
                            v-model="submission_date"
                            :disabled="isLoaddingData"
                          >
                            <v-radio
                              label="เรียงจากมากไปน้อย"
                              value="DESC"
                            ></v-radio>
                            <v-radio
                              label="เรียงจากน้อยไปมาก"
                              value="ASC"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pb-0 mb-0 pt-0">
                          <span
                            style="
                              color: #4347b3;
                              font-weight: bold;
                              font-size: 17px;
                            "
                            >ราคากลาง</span
                          >
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col class="pt-0 mt-0">
                          <v-radio-group
                            class="mt-0"
                            v-model="standard_price"
                            :disabled="isLoaddingData"
                          >
                            <v-radio
                              label="เรียงจากมากไปน้อย"
                              value="DESC"
                            ></v-radio>
                            <v-radio
                              label="เรียงจากน้อยไปมาก"
                              value="ASC"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-left pt-2 pb-0">
                      <span
                        style="
                          font-size: 22px;
                          color: #4347b3;
                          font-weight: bold;
                        "
                      >
                        โครงการเเนะนำ
                      </span>
                    </v-col>
                  </v-row>
                  <v-row
                    justify="center"
                    align="center"
                    v-for="(datalist_recommend, indexs) in datalists_recommend"
                    :key="indexs"
                  >
                    <v-col>
                      <v-card>
                        <v-container class="pt-0 pb-0">
                          <v-row justify="center" align="center">
                            <v-col
                              lg="4"
                              md="4"
                              class="pt-0 pb-0 pl-0"
                              @click="
                                openFullData(
                                  datalist_recommend.url,
                                  datalist_recommend.project_code
                                )
                              "
                            >
                              <v-img
                                style="
                                  border-top-left-radius: 4px;
                                  border-bottom-left-radius: 4px;
                                "
                                :src="datalist_recommend.image_url"
                                :lazy-src="datalist_recommend.image_url"
                              >
                              </v-img>
                            </v-col>
                            <v-col class="pt-0 pb-0">
                              <v-row justify="center" align="center">
                                <v-col
                                  @click="
                                    openFullData(
                                      datalist_recommend.url,
                                      datalist_recommend.project_code
                                    )
                                  "
                                  cols="8"
                                  sm="8"
                                  class="text-left pb-0 pt-1"
                                  style="color: #fe622a; font-size: 16px"
                                >
                                  {{ datalist_recommend.announcement_type }}
                                </v-col>
                                <v-col class="text-right pb-0 pt-1">
                                  <ShareNetwork
                                    network="line"
                                    :url="
                                      'https://www.kanpramool.com/showdatauser/' +
                                      datalist_recommend.project_code
                                    "
                                    :title="
                                      datalist_recommend.announcement_type +
                                      ': ' +
                                      ' [' +
                                      datalist_recommend.project_code +
                                      ']' +
                                      datalist_recommend.short_project_name
                                    "
                                  >
                                    <v-btn color="#913640" x-small dark>
                                      <v-icon x-small>
                                        mdi-share-variant
                                      </v-icon>
                                    </v-btn>
                                  </ShareNetwork>
                                </v-col>
                              </v-row>
                              <v-row
                                justify="center"
                                align="center"
                                @click="
                                  openFullData(
                                    datalist_recommend.url,
                                    datalist_recommend.project_code
                                  )
                                "
                              >
                                <v-col class="text-left pt-0 pb-0">
                                  <span style="color: #4367b2; font-size: 18px">
                                    {{
                                      datalist_recommend.type_of_work_id.substring(
                                        0,
                                        15
                                      )
                                    }}
                                  </span>
                                  <span
                                    style="color: #4367b2; font-size: 18px"
                                    v-if="
                                      datalist_recommend.type_of_work_id
                                        .length > 15
                                    "
                                  >
                                    ...
                                  </span>
                                </v-col>
                              </v-row>
                              <v-row
                                justify="center"
                                align="center"
                                @click="
                                  openFullData(
                                    datalist_recommend.url,
                                    datalist_recommend.project_code
                                  )
                                "
                              >
                                <v-col
                                  class="text-left pt-0 pb-0"
                                  v-if="
                                    datalist_recommend.announcement_type ===
                                    'ประกาศเชิญชวน'
                                  "
                                >
                                  <span style="font-size: 12px; color: #4367b2">
                                    ยื่นซอง
                                  </span>
                                  <span
                                    style="
                                      font-size: 14px;
                                      font-weight: bold;
                                      color: #4367b2;
                                    "
                                  >
                                    {{ datalist_recommend.date }}
                                  </span>
                                </v-col>
                                <v-col class="text-left pt-0 pb-0" v-else>
                                  <span style="font-size: 12px; color: #4367b2">
                                    สิ้นสุดประชามติ
                                  </span>
                                  <span
                                    style="
                                      font-size: 12px;
                                      font-weight: bold;
                                      color: #4367b2;
                                    "
                                  >
                                    {{ datalist_recommend.date }}
                                  </span>
                                </v-col>
                              </v-row>
                              <v-row
                                justify="center"
                                align="center"
                                @click="
                                  openFullData(
                                    datalist_recommend.url,
                                    datalist_recommend.project_code
                                  )
                                "
                              >
                                <v-col class="text-left pt-0 pb-0">
                                  <span style="font-size: 21px; color: #d83a52">{{
                                    (
                                      parseFloat(
                                        datalist_recommend.middle_price
                                      ) / 1000000
                                    )
                                      .toFixed(2)
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  }}</span>
                                  <span
                                    class="ml-1"
                                    style="font-size: 13px; color: #d83a52"
                                    >ล้านบาท</span
                                  >
                                </v-col>
                                <v-col class="text-right pt-0 pb-0">
                                  <span
                                    style="font-size: 14px; color: #d83a52"
                                    >{{ datalist_recommend.name_th }}</span
                                  >
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="text-center data_announce">
                  <div v-if="!no_data">
                    <v-row
                      justify="center"
                      align="center"
                      v-for="(datalist, indexs) in datalists"
                      :key="indexs"
                    >
                      <v-col>
                        <v-card>
                          <v-container class="pt-0 pb-0">
                            <v-row justify="center" align="center">
                              <v-col
                                cols="3"
                                sm="3"
                                class="pt-0 pb-0 pl-0"
                                @click="
                                  openFullData(
                                    datalist.url,
                                    datalist.project_code
                                  )
                                "
                              >
                                <v-img
                                  style="
                                    border-top-left-radius: 4px;
                                    border-bottom-left-radius: 4px;
                                  "
                                  :src="datalist.image_url"
                                  :lazy-src="datalist.image_url"
                                >
                                </v-img>
                              </v-col>
                              <v-col class="pt-0 pb-0 mr-3">
                                <v-row justify="center" align="center">
                                  <v-col
                                    @click="
                                      openFullData(
                                        datalist.url,
                                        datalist.project_code
                                      )
                                    "
                                    cols="8"
                                    sm="8"
                                    class="text-left pb-0 pt-1"
                                    style="color: #fe622a; font-size: 20px"
                                  >
                                    {{ datalist.announcement_type }}
                                  </v-col>
                                  <v-col class="text-right pb-0 pt-1">
                                    <ShareNetwork
                                      network="line"
                                      :url="
                                        'https://www.kanpramooll.com/showdatauser/' +
                                        datalist.project_code
                                      "
                                      :title="
                                        datalist.announcement_type +
                                        ': ' +
                                        ' [' +
                                        datalist.project_code +
                                        ']' +
                                        datalist.short_project_name
                                      "
                                    >
                                      <v-btn color="#913640" dark small>
                                        <v-icon small>
                                          mdi-share-variant
                                        </v-icon>
                                      </v-btn>
                                    </ShareNetwork>
                                  </v-col>
                                </v-row>
                                <v-row
                                  justify="center"
                                  align="center"
                                  @click="
                                    openFullData(
                                      datalist.url,
                                      datalist.project_code
                                    )
                                  "
                                >
                                  <v-col
                                    class="text-left pt-1 pb-1"
                                    v-if="
                                      datalist.short_project_name !== null &&
                                      datalist.short_project_name !== ''
                                    "
                                  >
                                    <span
                                      style="color: #4367b2; font-size: 14px"
                                    >
                                      {{
                                        datalist.short_project_name.substring(
                                          0,
                                          60
                                        )
                                      }}
                                    </span>
                                    <span
                                      style="color: #4367b2; font-size: 14px"
                                      v-if="
                                        datalist.short_project_name.length > 60
                                      "
                                    >
                                      ...
                                    </span>
                                  </v-col>
                                  <v-col class="text-left pt-1 pb-1" v-else>
                                    <span
                                      style="color: #4367b2; font-size: 14px"
                                    >
                                      {{
                                        datalist.project_name.substring(14, 60)
                                      }}
                                    </span>
                                    <span
                                      style="color: #4367b2; font-size: 14px"
                                      v-if="datalist.project_name.length > 60"
                                    >
                                      ...
                                    </span>
                                  </v-col>
                                </v-row>
                                <v-row
                                  justify="center"
                                  align="center"
                                  @click="
                                    openFullData(
                                      datalist.url,
                                      datalist.project_code
                                    )
                                  "
                                >
                                  <v-col class="text-left pt-1 pb-1">
                                    <span
                                      style="color: #4367b2; font-size: 17px"
                                    >
                                      {{
                                        datalist.type_of_work_id.substring(
                                          0,
                                          50
                                        )
                                      }}
                                    </span>
                                    <span
                                      style="color: #4367b2; font-size: 17px"
                                      v-if="
                                        datalist.type_of_work_id.length > 50
                                      "
                                    >
                                      ...
                                    </span>
                                  </v-col>
                                </v-row>
                                <v-row
                                  justify="center"
                                  align="center"
                                  @click="
                                    openFullData(
                                      datalist.url,
                                      datalist.project_code
                                    )
                                  "
                                >
                                  <v-col
                                    class="text-left pt-0 pb-0"
                                    v-if="
                                      datalist.announcement_type ===
                                      'ประกาศเชิญชวน'
                                    "
                                  >
                                    <span
                                      style="font-size: 17px; color: #4367b2"
                                    >
                                      ยื่นซอง
                                    </span>
                                    <span
                                      style="
                                        font-size: 19px;
                                        font-weight: bold;
                                        color: #4367b2;
                                      "
                                    >
                                      {{ datalist.date }}
                                    </span>
                                  </v-col>
                                  <v-col class="text-left pt-0 pb-0" v-else>
                                    <span
                                      style="font-size: 17px; color: #4367b2"
                                    >
                                      สิ้นสุดประชามติ
                                    </span>
                                    <span
                                      style="
                                        font-size: 19px;
                                        font-weight: bold;
                                        color: #4367b2;
                                      "
                                    >
                                      {{ datalist.date }}
                                    </span>
                                  </v-col>
                                </v-row>
                                <v-row
                                  justify="center"
                                  align="center"
                                  @click="
                                    openFullData(
                                      datalist.url,
                                      datalist.project_code
                                    )
                                  "
                                >
                                  <v-col class="text-left pt-0 pb-1">
                                    <span
                                      style="font-size: 27px; color: #d83a52"
                                      >{{
                                        parseFloat(datalist.middle_price)
                                          .toFixed(2)
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      }}</span
                                    >
                                    <span
                                      class="ml-4"
                                      style="font-size: 15px; color: #d83a52"
                                      >บาท</span
                                    >
                                  </v-col>
                                  <v-col class="text-right pt-0 pb-1">
                                    <span
                                      style="font-size: 21px; color: #d83a52"
                                      >{{ datalist.name_th }}</span
                                    >
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else>
                    <v-icon x-large color="red"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <br />
                    <span
                      style="font-size: 20px; color: #4347b3; font-weight: bold"
                    >
                      ไม่พบประกาศที่ค้นหา
                    </span>
                  </div>
                </v-col>
                <v-col lg="2" md="2"></v-col>
              </v-row>
              <v-row v-if="!no_data" class="pagination">
                <v-col>
                  <v-pagination
                    @input="changePage()"
                    v-model="form.page"
                    :length="pages"
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-lazy>
      </div>
    </div>
    <div class="tablet" v-else-if="display === 'Tablet'">
      <div class="loadding_content" v-if="isLoadding">
        <v-container
          fill-height
          :style="'height: ' + (heightDisplay - 100) + 'px;'"
        >
          <v-row align="center" justify="center">
            <v-col class="text-center">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <h1 style="font-size: 70px">
                    <span style="color: #3f44a3">Kan</span>
                    <span style="color: #4a98b2">Pramool</span>
                  </h1>
                  <h3><b>กำลังเตรียมข้อมูล</b></h3>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col class="text-center" cols="6" sm="6">
                  <v-progress-linear
                    color="#F8F364"
                    indeterminate
                    rounded
                    height="8"
                  >
                  </v-progress-linear>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="data_content" v-else>
        <v-lazy
          v-model="isActive"
          :options="{
            threshold: 0.5,
          }"
          min-height="200"
          transition="fade-transition"
        >
          <div>
            <APPBAR></APPBAR>
            <v-card class="tab-top">
              <v-container>
                <v-row>
                  <v-col class="pt-2 pb-2" cols="8" sm="8" md="8">
                    <v-autocomplete
                      :menu-props="{ closeOnContentClick: true }"
                      @change="clearKeyboard()"
                      :disabled="isLoaddingData"
                      v-model="form.province"
                      :items="provinces"
                      hide-details
                      append-icon="mdi-magnify"
                      outlined
                      chips
                      dense
                      small-chips
                      clearable
                      hide-selected
                      label="เลือกจังหวัด"
                      item-text="name_th"
                      item-value="id"
                      multiple
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          close
                          small
                          class="chip--select-multi"
                          @click:close="removeProvince(data.item)"
                        >
                          {{ data.item.name_th }}
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item">
                          </v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content v-html="data.item.name_th">
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col class="pt-2 pb-2" cols="4" sm="4" md="4">
                    <v-select
                      ref="keyboard"
                      :disabled="isLoaddingData"
                      outlined
                      dense
                      v-model="form.jobtype"
                      :items="jobtypes"
                      item-text="job_type_name"
                      item-value="job_type_id"
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col class="pt-2 pb-2">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :disabled="isLoaddingData"
                      :close-on-content-click="false"
                      :return-value.sync="date1"
                      transition="scale-transition"
                      min-width="290px"
                      max-width="290px"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          v-model="dateFormatted1"
                          hide-details
                          v-on="on"
                          outlined
                          dense
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date1"
                        @input="$refs.menu1.save(date1)"
                        scrollable
                        locale="TH-th"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="pt-2 pb-2">
                    <v-menu
                      ref="menu2"
                      :disabled="isLoaddingData"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :return-value.sync="date2"
                      transition="scale-transition"
                      min-width="290px"
                      max-width="290px"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          v-model="dateFormatted2"
                          hide-details
                          v-on="on"
                          outlined
                          dense
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date2"
                        @input="$refs.menu2.save(date2)"
                        scrollable
                        locale="TH-th"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="pt-2 pb-2">
                    <v-btn
                      block
                      color="#4347B3"
                      @click="searchFn(true)"
                      :disabled="isLoaddingData"
                    >
                      <h4 style="font-size: 15px; color: white">ค้นหา</h4>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-container v-if="isLoaddingData">
              <v-row justify="center" align="start">
                <v-col sm="3" cols="3" md="3">
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 mb-0">
                      <span
                        style="
                          color: #4347b3;
                          font-weight: bold;
                          font-size: 17px;
                        "
                      >
                        ประเภทประกาศ</span
                      >
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 pt-0 mb-0 mt-0">
                      <v-radio-group
                        class="mt-0"
                        v-model="announcement_type"
                        :disabled="isLoaddingData"
                      >
                        <v-radio label="ร่าง ToR" value="tor"></v-radio>
                        <v-radio label="เชิญชวน" value="invite"></v-radio>
                        <v-radio
                          v-if="false"
                          label="ผู้ชนะ"
                          value="ebidding"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 mb-0">
                      <span
                        style="
                          color: #4347b3;
                          font-weight: bold;
                          font-size: 17px;
                        "
                      >
                        วันที่ยื่นซอง</span
                      >
                      <v-radio-group
                        class="mt-0"
                        v-model="submission_date"
                        :disabled="isLoaddingData"
                      >
                        <v-radio
                          label="เรียงจากมากไปน้อย"
                          value="DESC"
                        ></v-radio>
                        <v-radio
                          label="เรียงจากน้อยไปมาก"
                          value="ASC"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 mb-0">
                      <span
                        style="
                          color: #4347b3;
                          font-weight: bold;
                          font-size: 17px;
                        "
                      >
                        ราคากลาง</span
                      >
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 mb-0 pt-0">
                      <v-radio-group
                        class="mt-0"
                        v-model="standard_price"
                        :disabled="isLoaddingData"
                      >
                        <v-radio
                          label="เรียงจากมากไปน้อย"
                          value="DESC"
                        ></v-radio>
                        <v-radio
                          label="เรียงจากน้อยไปมาก"
                          value="ASC"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="text-center">
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col> </v-row
                  ><v-row justify="center" align="center">
                    <v-col>
                      <v-card>
                        <v-skeleton-loader type="article"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-else>
              <v-row justify="center" align="start">
                <v-col sm="3" cols="3" md="3">
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 mb-0">
                      <span
                        style="
                          color: #4347b3;
                          font-weight: bold;
                          font-size: 17px;
                        "
                      >
                        ประเภทประกาศ</span
                      >
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 pt-0 mb-0 mt-0">
                      <v-radio-group
                        class="mt-0"
                        v-model="announcement_type"
                        :disabled="isLoaddingData"
                      >
                        <v-radio label="ร่าง ToR" value="tor"></v-radio>
                        <v-radio label="เชิญชวน" value="invite"></v-radio>
                        <v-radio
                          v-if="false"
                          label="ผู้ชนะ"
                          value="ebidding"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 mb-0">
                      <span
                        style="
                          color: #4347b3;
                          font-weight: bold;
                          font-size: 17px;
                        "
                      >
                        วันที่ยื่นซอง</span
                      >
                      <v-radio-group
                        class="mt-0"
                        v-model="submission_date"
                        :disabled="isLoaddingData"
                      >
                        <v-radio
                          label="เรียงจากมากไปน้อย"
                          value="DESC"
                        ></v-radio>
                        <v-radio
                          label="เรียงจากน้อยไปมาก"
                          value="ASC"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 mb-0">
                      <span
                        style="
                          color: #4347b3;
                          font-weight: bold;
                          font-size: 17px;
                        "
                      >
                        ราคากลาง</span
                      >
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="pb-0 mb-0 pt-0">
                      <v-radio-group
                        class="mt-0"
                        v-model="standard_price"
                        :disabled="isLoaddingData"
                      >
                        <v-radio
                          label="เรียงจากมากไปน้อย"
                          value="DESC"
                        ></v-radio>
                        <v-radio
                          label="เรียงจากน้อยไปมาก"
                          value="ASC"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <div v-if="!no_data">
                    <v-row
                      justify="center"
                      align="center"
                      v-for="(datalist, indexs) in datalists"
                      :key="indexs"
                    >
                      <v-col>
                        <v-card>
                          <v-container class="pt-0 pb-0">
                            <v-row justify="center" align="center">
                              <v-col
                                cols="4"
                                sm="4"
                                class="pt-0 pb-0 pl-0"
                                @click="
                                  openFullData(
                                    datalist.url,
                                    datalist.project_code
                                  )
                                "
                              >
                                <v-img
                                  style="
                                    border-top-left-radius: 4px;
                                    border-bottom-left-radius: 4px;
                                  "
                                  :src="datalist.image_url"
                                  :lazy-src="datalist.image_url"
                                >
                                </v-img>
                              </v-col>
                              <v-col class="pt-0 pb-0">
                                <v-row justify="center" align="center">
                                  <v-col
                                    @click="
                                      openFullData(
                                        datalist.url,
                                        datalist.project_code
                                      )
                                    "
                                    cols="8"
                                    sm="8"
                                    class="text-left pb-0 pt-1"
                                    style="color: #fe622a; font-size: 20px"
                                  >
                                    {{ datalist.announcement_type }}
                                  </v-col>
                                  <v-col class="text-right pb-0 pt-1">
                                    <ShareNetwork
                                      network="line"
                                      :url="
                                        'https://www.kanpramooll.com/showdatauser/' +
                                        datalist.project_code
                                      "
                                      :title="
                                        datalist.announcement_type +
                                        ': ' +
                                        ' [' +
                                        datalist.project_code +
                                        ']' +
                                        datalist.short_project_name
                                      "
                                    >
                                      <v-btn color="#913640" small dark>
                                        <v-icon small>
                                          mdi-share-variant
                                        </v-icon>
                                      </v-btn>
                                    </ShareNetwork>
                                  </v-col>
                                </v-row>
                                <v-row
                                  justify="center"
                                  align="center"
                                  @click="
                                    openFullData(
                                      datalist.url,
                                      datalist.project_code
                                    )
                                  "
                                >
                                  <v-col class="text-left pt-0 pb-1">
                                    <span
                                      style="color: #4367b2; font-size: 16px"
                                    >
                                      {{
                                        datalist.type_of_work_id.substring(
                                          0,
                                          30
                                        )
                                      }}
                                    </span>
                                    <span
                                      style="color: #4367b2; font-size: 16px"
                                      v-if="
                                        datalist.type_of_work_id.length > 30
                                      "
                                    >
                                      ...
                                    </span>
                                  </v-col>
                                </v-row>
                                <v-row
                                  justify="center"
                                  align="center"
                                  @click="
                                    openFullData(
                                      datalist.url,
                                      datalist.project_code
                                    )
                                  "
                                >
                                  <v-col
                                    class="text-left pt-1 pb-2"
                                    v-if="
                                      datalist.short_project_name !== null &&
                                      datalist.short_project_name !== ''
                                    "
                                  >
                                    <span
                                      style="color: #4367b2; font-size: 14px"
                                    >
                                      {{
                                        datalist.short_project_name.substring(
                                          0,
                                          35
                                        )
                                      }}
                                    </span>
                                    <span
                                      style="color: #4367b2; font-size: 14px"
                                      v-if="
                                        datalist.short_project_name.length > 35
                                      "
                                    >
                                      ...
                                    </span>
                                  </v-col>
                                  <v-col class="text-left pt-1 pb-2" v-else>
                                    <span
                                      style="color: #4367b2; font-size: 14px"
                                    >
                                      {{
                                        datalist.project_name.substring(14, 35)
                                      }}
                                    </span>
                                    <span
                                      style="color: #4367b2; font-size: 14px"
                                      v-if="datalist.project_name.length > 35"
                                    >
                                      ...
                                    </span>
                                  </v-col>
                                </v-row>
                                <v-row
                                  justify="center"
                                  align="center"
                                  @click="
                                    openFullData(
                                      datalist.url,
                                      datalist.project_code
                                    )
                                  "
                                >
                                  <v-col
                                    class="text-left pt-2 pb-0"
                                    v-if="
                                      datalist.announcement_type ===
                                      'ประกาศเชิญชวน'
                                    "
                                  >
                                    <span
                                      style="font-size: 18px; color: #4367b2"
                                    >
                                      ยื่นซอง
                                    </span>
                                    <span
                                      style="
                                        font-size: 20px;
                                        font-weight: bold;
                                        color: #4367b2;
                                      "
                                    >
                                      {{ datalist.date }}
                                    </span>
                                  </v-col>
                                  <v-col class="text-left pt-2 pb-0" v-else>
                                    <span
                                      style="font-size: 18px; color: #4367b2"
                                    >
                                      สิ้นสุดประชามติ
                                    </span>
                                    <span
                                      style="
                                        font-size: 20px;
                                        font-weight: bold;
                                        color: #4367b2;
                                      "
                                    >
                                      {{ datalist.date }}
                                    </span>
                                  </v-col>
                                </v-row>
                                <v-row
                                  justify="center"
                                  align="center"
                                  @click="
                                    openFullData(
                                      datalist.url,
                                      datalist.project_code
                                    )
                                  "
                                >
                                  <v-col class="text-left pt-0 pb-1">
                                    <span
                                      style="font-size: 26px; color: #d83a52"
                                      >{{
                                        datalist.middle_price.replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )
                                      }}</span
                                    >
                                    <span
                                      class="ml-2"
                                      style="font-size: 18px; color: #d83a52"
                                      >บาท</span
                                    >
                                  </v-col>
                                  <v-col class="text-right pt-0 pb-1">
                                    <span
                                      style="font-size: 21px; color: #d83a52"
                                      >{{ datalist.name_th }}</span
                                    >
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row
                    v-else
                    justify="center"
                    align="center"
                    class="mt-4 mb-4 pb-4"
                  >
                    <v-col cols="1" sm="1"></v-col>
                    <v-col class="text-center mt-3 mb-6">
                      <v-icon x-large color="red"
                        >mdi-alert-circle-outline</v-icon
                      >
                      <br />
                      <span
                        style="
                          font-size: 20px;
                          color: #4347b3;
                          font-weight: bold;
                        "
                      >
                        ไม่พบประกาศที่ค้นหา
                      </span>
                    </v-col>
                    <v-col cols="1" sm="1"></v-col>
                  </v-row>
                  <!-- <v-row justify="center" align="center" class="mt-7 pb-0">
                    <v-col class="text-left pb-0 pt-4">
                      <span
                        style="
                          font-size: 28px;
                          color: #4347b3;
                          font-weight: bold;
                        "
                      >
                        โครงการเเนะนำ
                      </span>
                    </v-col>
                  </v-row>
                  <v-row
                    class="data_recommend"
                    justify="center"
                    align="center"
                    v-for="(datalist_recommend, index) in datalists_recommend"
                    :key="index"
                  >
                    <v-col>
                      <v-card>
                        <v-container class="pt-0 pb-0">
                          <v-row justify="center" align="center">
                            <v-col
                              cols="4"
                              sm="4"
                              class="pt-0 pb-0 pl-0"
                              @click="
                                openFullData(
                                  datalist_recommend.url,
                                  datalist_recommend.project_code
                                )
                              "
                            >
                              <v-img
                                style="
                                  border-top-left-radius: 4px;
                                  border-bottom-left-radius: 4px;
                                "
                                :src="datalist_recommend.image_url"
                                :lazy-src="datalist_recommend.image_url"
                              >
                              </v-img>
                            </v-col>
                            <v-col class="pt-0 pb-0">
                              <v-row justify="center" align="center">
                                <v-col
                                  @click="
                                    openFullData(
                                      datalist_recommend.url,
                                      datalist_recommend.project_code
                                    )
                                  "
                                  cols="8"
                                  sm="8"
                                  class="text-left pb-0 pt-1"
                                  style="color: #fe622a; font-size: 20px"
                                >
                                  {{ datalist_recommend.announcement_type }}
                                </v-col>
                                <v-col class="text-right pb-0 pt-1">
                                  <ShareNetwork
                                    network="line"
                                    :url="
                                      'https://www.kanpramooll.com/showdatauser/' +
                                      datalist_recommend.project_code
                                    "
                                    :title="
                                      datalist_recommend.announcement_type +
                                      ': ' +
                                      ' [' +
                                      datalist_recommend.project_code +
                                      ']' +
                                      datalist_recommend.short_project_name
                                    "
                                  >
                                    <v-btn color="#913640" small dark>
                                      <v-icon small> mdi-share-variant </v-icon>
                                    </v-btn>
                                  </ShareNetwork>
                                </v-col>
                              </v-row>
                              <v-row
                                justify="center"
                                align="center"
                                @click="
                                  openFullData(
                                    datalist_recommend.url,
                                    datalist_recommend.project_code
                                  )
                                "
                              >
                                <v-col class="text-left pt-0 pb-1">
                                  <span style="color: #4367b2; font-size: 16px">
                                    {{
                                      datalist_recommend.type_of_work_id.substring(
                                        0,
                                        30
                                      )
                                    }}
                                  </span>
                                  <span
                                    style="color: #4367b2; font-size: 16px"
                                    v-if="
                                      datalist_recommend.type_of_work_id
                                        .length > 30
                                    "
                                  >
                                    ...
                                  </span>
                                </v-col>
                              </v-row>
                              <v-row
                                justify="center"
                                align="center"
                                @click="
                                  openFullData(
                                    datalist_recommend.url,
                                    datalist_recommend.project_code
                                  )
                                "
                              >
                                <v-col
                                  class="text-left pt-0 pb-2"
                                  v-if="
                                    datalist_recommend.short_project_name !==
                                      null &&
                                    datalist_recommend.short_project_name !== ''
                                  "
                                >
                                  <span style="color: #4367b2; font-size: 14px">
                                    {{
                                      datalist_recommend.short_project_name.substring(
                                        0,
                                        40
                                      )
                                    }}
                                  </span>
                                  <span
                                    style="color: #4367b2; font-size: 14px"
                                    v-if="
                                      datalist_recommend.short_project_name
                                        .length > 40
                                    "
                                  >
                                    ...
                                  </span>
                                </v-col>
                                <v-col class="text-left pt-1 pb-2" v-else>
                                  <span style="color: #4367b2; font-size: 14px">
                                    {{
                                      datalist_recommend.project_name.substring(
                                        14,
                                        40
                                      )
                                    }}
                                  </span>
                                  <span
                                    style="color: #4367b2; font-size: 14px"
                                    v-if="
                                      datalist_recommend.project_name.length >
                                      40
                                    "
                                  >
                                    ...
                                  </span>
                                </v-col>
                              </v-row>
                              <v-row
                                justify="center"
                                align="center"
                                @click="
                                  openFullData(
                                    datalist_recommend.url,
                                    datalist_recommend.project_code
                                  )
                                "
                              >
                                <v-col
                                  class="text-left pt-1 pb-1"
                                  v-if="
                                    datalist_recommend.announcement_type ===
                                    'ประกาศเชิญชวน'
                                  "
                                >
                                  <span style="font-size: 18px; color: #4367b2">
                                    ยื่นซอง
                                  </span>
                                  <span
                                    style="
                                      font-size: 20px;
                                      font-weight: bold;
                                      color: #4367b2;
                                    "
                                  >
                                    {{ datalist_recommend.date }}
                                  </span>
                                </v-col>
                                <v-col class="text-left pt-1 pb-1" v-else>
                                  <span style="font-size: 18px; color: #4367b2">
                                    สิ้นสุดประชามติ
                                  </span>
                                  <span
                                    style="
                                      font-size: 20px;
                                      font-weight: bold;
                                      color: #4367b2;
                                    "
                                  >
                                    {{ datalist_recommend.date }}
                                  </span>
                                </v-col>
                              </v-row>
                              <v-row
                                justify="center"
                                align="center"
                                @click="
                                  openFullData(
                                    datalist_recommend.url,
                                    datalist_recommend.project_code
                                  )
                                "
                              >
                                <v-col class="text-left pt-0 pb-1">
                                  <span style="font-size: 26px; color: #d83a52">{{
                                    datalist_recommend.middle_price
                                      .toFixed(2)
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  }}</span>
                                  <span
                                    class="ml-2"
                                    style="font-size: 18px; color: #d83a52"
                                    >บาท</span
                                  >
                                </v-col>
                                <v-col class="text-right pt-0 pb-1">
                                  <span
                                    style="font-size: 21px; color: #d83a52"
                                    >{{ datalist_recommend.name_th }}</span
                                  >
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-col>
                  </v-row> -->
                  <v-row v-if="!no_data" class="pagination">
                    <v-col>
                      <v-pagination
                        @input="changePage()"
                        v-model="form.page"
                        :length="pages"
                      ></v-pagination>
                    </v-col>
                  </v-row> </v-col
              ></v-row>
            </v-container>
          </div>
        </v-lazy>
      </div>
    </div>
    <div class="mobile" v-else>
      <div class="loadding_content" v-if="isLoadding">
        <v-container
          fill-height
          :style="'height: ' + (heightDisplay - 225) + 'px;'"
        >
          <v-row align="center" justify="center">
            <v-col class="text-center">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <h1 style="font-size: 40px">
                    <span style="color: #3f44a3">Kan</span>
                    <span style="color: #4a98b2">Pramool</span>
                  </h1>
                  <h5><b>กำลังเตรียมข้อมูล</b></h5>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col class="text-center" cols="7" sm="7">
                  <v-progress-linear
                    color="#F8F364"
                    indeterminate
                    rounded
                    height="8"
                  >
                  </v-progress-linear>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="data_content" v-else>
        <v-lazy
          v-model="isActive"
          :options="{
            threshold: 0.5,
          }"
          min-height="200"
          transition="fade-transition"
        >
          <div>
            <APPBAR></APPBAR>
            <v-expansion-panels
              v-model="panel"
              flat
              style="border: 1px solid #dcdcdc"
            >
              <v-expansion-panel>
                <v-expansion-panel-header class="pb-0 pt-0">
                  <span style="color: #4347b3; font-size: 14px">
                    ค้นหางานก่อสร้างภาครัฐที่ตรงใจผู้รับเหมาเช่นคุณ
                  </span>
                  <template v-slot:actions>
                    <v-icon color="primary">
                      mdi-arrow-down-drop-circle
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container class="pt-0">
                    <v-row justify="center" align="center">
                      <v-col class="pt-2 pb-2" cols="12">
                        <v-autocomplete
                          :menu-props="{ closeOnContentClick: true }"
                          @change="clearKeyboard()"
                          :disabled="isLoaddingData"
                          v-model="form.province"
                          :items="provinces"
                          hide-details
                          append-icon="mdi-magnify"
                          outlined
                          chips
                          dense
                          small-chips
                          clearable
                          hide-selected
                          label="ค้นหา"
                          item-text="name_th"
                          item-value="id"
                          multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              close
                              small
                              class="chip--select-multi"
                              @click:close="removeProvince(data.item)"
                            >
                              {{ data.item.name_th }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item">
                              </v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content v-html="data.item.name_th">
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="pt-2 pb-2">
                        <v-menu
                          ref="menu1"
                          v-model="menu1"
                          :disabled="isLoaddingData"
                          :close-on-content-click="false"
                          :return-value.sync="date1"
                          transition="scale-transition"
                          min-width="290px"
                          max-width="290px"
                          offset-y
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              prepend-inner-icon="mdi-calendar"
                              v-bind="attrs"
                              v-model="dateFormatted1"
                              hide-details
                              v-on="on"
                              outlined
                              dense
                              readonly
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="date1"
                            @input="$refs.menu1.save(date1)"
                            scrollable
                            locale="TH-th"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="pt-2 pb-2">
                        <v-menu
                          ref="menu2"
                          :disabled="isLoaddingData"
                          v-model="menu2"
                          :close-on-content-click="false"
                          :return-value.sync="date2"
                          transition="scale-transition"
                          min-width="290px"
                          max-width="290px"
                          offset-y
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              prepend-inner-icon="mdi-calendar"
                              v-bind="attrs"
                              v-model="dateFormatted2"
                              hide-details
                              v-on="on"
                              outlined
                              dense
                              readonly
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="date2"
                            @input="$refs.menu2.save(date2)"
                            scrollable
                            locale="TH-th"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="pt-2 pb-2">
                        <v-select
                          ref="keyboard"
                          :disabled="isLoaddingData"
                          outlined
                          dense
                          v-model="form.jobtype"
                          :items="jobtypes"
                          item-text="job_type_name"
                          item-value="job_type_id"
                          hide-details
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="pt-2 pb-2">
                        <v-btn
                          block
                          small
                          color="#4347B3"
                          @click="searchFn(true)"
                          :disabled="isLoaddingData"
                        >
                          <h4 style="font-size: 13px; color: white">ค้นหา</h4>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-expansion-panels
              v-model="panel_filter"
              flat
              style="border: 1px solid #dcdcdc"
            >
              <v-expansion-panel>
                <v-expansion-panel-header class="pb-0 pt-0">
                  <span style="color: #4347b3; font-size: 14px">
                    จัดเรียงเเละการกรองข้อมูล
                  </span>
                  <template v-slot:actions>
                    <v-icon color="primary">
                      mdi-arrow-down-drop-circle
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container class="pt-0">
                    <v-row justify="center" align="center">
                      <v-col class="pb-0 mb-0 pt-0">
                        <span
                          style="
                            color: #4347b3;
                            font-weight: bold;
                            font-size: 17px;
                          "
                        >
                          ประเภทประกาศ</span
                        >
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="pb-0 pt-0 mb-0 mt-0">
                        <v-radio-group
                          class="mt-0"
                          v-model="announcement_type"
                          :disabled="isLoaddingData"
                        >
                          <v-radio label="ร่าง ToR" value="tor"></v-radio>
                          <v-radio label="เชิญชวน" value="invite"></v-radio>
                          <v-radio
                            v-if="false"
                            label="ผู้ชนะ"
                            value="ebidding"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="pb-0 mb-0">
                        <span
                          style="
                            color: #4347b3;
                            font-weight: bold;
                            font-size: 17px;
                          "
                        >
                          วันที่ยื่นซอง</span
                        >
                        <v-radio-group
                          class="mt-0"
                          v-model="submission_date"
                          :disabled="isLoaddingData"
                        >
                          <v-radio
                            label="เรียงจากมากไปน้อย"
                            value="DESC"
                          ></v-radio>
                          <v-radio
                            label="เรียงจากน้อยไปมาก"
                            value="ASC"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="pb-0 mb-0">
                        <span
                          style="
                            color: #4347b3;
                            font-weight: bold;
                            font-size: 17px;
                          "
                        >
                          ราคากลาง</span
                        >
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="pb-0 mb-0 pt-0">
                        <v-radio-group
                          class="mt-0"
                          v-model="standard_price"
                          :disabled="isLoaddingData"
                        >
                          <v-radio
                            label="เรียงจากมากไปน้อย"
                            value="DESC"
                          ></v-radio>
                          <v-radio
                            label="เรียงจากน้อยไปมาก"
                            value="ASC"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-container v-if="isLoaddingData" class="skeleton_content">
              <v-row justify="center" align="center">
                <v-col>
                  <v-card>
                    <v-skeleton-loader type="article"></v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col>
                  <v-card>
                    <v-skeleton-loader type="article"></v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col>
                  <v-card>
                    <v-skeleton-loader type="article"></v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col>
                  <v-card>
                    <v-skeleton-loader type="article"></v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col>
                  <v-card>
                    <v-skeleton-loader type="article"></v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-else class="data_announce">
              <div v-if="!no_data">
                <v-row
                  justify="center"
                  align="center"
                  v-for="(datalist, indexs) in datalists"
                  :key="indexs"
                >
                  <v-col>
                    <v-card>
                      <v-container class="pt-0 pb-0">
                        <v-row justify="center" align="center">
                          <v-col
                            cols="4"
                            sm="4"
                            class="pt-0 pb-0 pl-0"
                            @click="
                              openFullData(datalist.url, datalist.project_code)
                            "
                          >
                            <v-img
                              style="
                                border-top-left-radius: 4px;
                                border-bottom-left-radius: 4px;
                              "
                              :src="datalist.image_url"
                              :lazy-src="datalist.image_url"
                            >
                            </v-img>
                          </v-col>
                          <v-col class="pt-0 pb-0">
                            <v-row justify="center" align="center">
                              <v-col
                                @click="
                                  openFullData(
                                    datalist.url,
                                    datalist.project_code
                                  )
                                "
                                cols="8"
                                sm="8"
                                class="text-left pb-0 pt-1"
                                style="color: #fe622a; font-size: 14px"
                              >
                                {{ datalist.announcement_type }}
                              </v-col>
                              <v-col class="text-right pb-0 pt-1">
                                <ShareNetwork
                                  network="line"
                                  :url="
                                    'https://www.kanpramooll.com/showdatauser/' +
                                    datalist.project_code
                                  "
                                  :title="
                                    datalist.announcement_type +
                                    ': ' +
                                    ' [' +
                                    datalist.project_code +
                                    ']' +
                                    datalist.short_project_name
                                  "
                                >
                                  <v-btn color="#913640" x-small dark>
                                    <v-icon x-small> mdi-share-variant </v-icon>
                                  </v-btn>
                                </ShareNetwork>
                              </v-col>
                            </v-row>
                            <v-row
                              justify="center"
                              align="center"
                              @click="
                                openFullData(
                                  datalist.url,
                                  datalist.project_code
                                )
                              "
                            >
                              <v-col class="text-left pt-0 pb-0">
                                <span style="color: #4367b2; font-size: 12px">
                                  {{
                                    datalist.type_of_work_id.substring(0, 20)
                                  }}
                                </span>
                                <span
                                  style="color: #4367b2; font-size: 12px"
                                  v-if="datalist.type_of_work_id.length > 20"
                                >
                                  ...
                                </span>
                              </v-col>
                            </v-row>
                            <v-row
                              justify="center"
                              align="center"
                              @click="
                                openFullData(
                                  datalist.url,
                                  datalist.project_code
                                )
                              "
                            >
                              <v-col
                                class="text-left pt-0 pb-0"
                                v-if="
                                  datalist.announcement_type === 'ประกาศเชิญชวน'
                                "
                              >
                                <span style="font-size: 12px; color: #4367b2">
                                  ยื่นซอง
                                </span>
                                <span
                                  style="
                                    font-size: 14px;
                                    font-weight: bold;
                                    color: #4367b2;
                                  "
                                >
                                  {{ datalist.date }}
                                </span>
                              </v-col>
                              <v-col class="text-left pt-0 pb-0" v-else>
                                <span style="font-size: 11px; color: #4367b2">
                                  สิ้นสุดประชามติ
                                </span>
                                <span
                                  style="
                                    font-size: 13px;
                                    font-weight: bold;
                                    color: #4367b2;
                                  "
                                >
                                  {{ datalist.date }}
                                </span>
                              </v-col>
                            </v-row>
                            <v-row
                              justify="center"
                              align="center"
                              @click="
                                openFullData(
                                  datalist.url,
                                  datalist.project_code
                                )
                              "
                            >
                              <v-col class="text-left pt-0 pb-0">
                                <span style="font-size: 16px; color: #d83a52">{{
                                  (parseFloat(datalist.middle_price) / 1000000)
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                }}</span>
                                <span
                                  class="ml-0"
                                  style="font-size: 8px; color: #d83a52"
                                >
                                  ล้านบาท</span
                                >
                              </v-col>
                              <v-col class="text-right pt-0 pb-0">
                                <span style="font-size: 11px; color: #d83a52">{{
                                  datalist.name_th
                                }}</span>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <v-row
                v-else
                justify="center"
                align="center"
                class="mt-4 mb-4 pb-4"
              >
                <v-col class="text-center mt-3 mb-6">
                  <v-icon x-large color="red">mdi-alert-circle-outline</v-icon>
                  <br />
                  <span
                    style="font-size: 20px; color: #4347b3; font-weight: bold"
                  >
                    ไม่พบประกาศที่ค้นหา
                  </span>
                </v-col>
              </v-row>
              <v-row v-if="!no_data" class="pagination">
                <v-col>
                  <v-pagination
                    @input="changePage()"
                    v-model="form.page"
                    :length="pages"
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-lazy>
      </div>
    </div>
  </div>
</template>

<script>
import APPBAR from "../components/appBar";
export default {
  name: "ListCardPage",
  components: { APPBAR },
  data: () => ({
    announcement_type: "invite",
    panel_filter: 0,
    panel: 0,
    tor: false,
    ebidding: false,
    invite: true,
    isActive: false,
    isLoadding: true,
    heightDisplay: null,
    display: null,
    provinces: [],
    jobtypes: [],
    pages: 0,
    isLoaddingData: false,
    date1: null,
    menu1: false,
    dateFormatted1: null,
    date2: null,
    menu2: false,
    dateFormatted2: null,
    menu3: false,
    menu4: false,
    standard_price: "DESC",
    submission_date: "DESC",
    form: {
      standard_price: "DESC",
      submission_date: "DESC",
      username: null,
      announcement_type: "invite",
      page: 1,
      province: [],
      jobtype: "All",
      start_date: null,
      end_date: null,
      ipaddress: null,
      click: true,
    },
    datalists: [],
    datalists_recommend: [],
    images_type: {
      A: "งานคอนกรีต.png",
      B: "งานแอสฟัลท์ติก.png",
      C: "งานระบบประปา.png",
      D: "งานระบบไฟฟ้า.png",
      E: "งานอาคาร.png",
      F: "งานปรับปรุง.png",
      G: "งานพื้นที่บริเวณ.png",
      H: "งานโยธา.png",
      I: "งานจัดซื้อจัดจ้างวัสดุ.png",
      J: "งานดิน.png",
      K: "งานเขื่อน.png",
      L: "งานสะพาน.png",
      M: "งานอื่นๆ.png",
    },
    no_data: false,
  }),
  watch: {
    announcement_type() {
      this.isLoaddingData = true;
      this.panel = null;
      this.panel_filter = null;
      this.$vuetify.goTo(0);
      this.form.page = 1;
      this.form.announcement_type = this.announcement_type;
      this.searchFn().then(() => {
        this.getRecommend().then(() => {
          this.loaddingData();
        });
      });
    },
    submission_date() {
      this.isLoaddingData = true;
      this.panel = null;
      this.panel_filter = null;
      this.form.submission_date = this.submission_date;
      this.searchFn().then(() => {
        this.getRecommend().then(() => {
          this.loaddingData();
        });
      });
    },
    standard_price() {
      this.isLoaddingData = true;
      this.panel = null;
      this.panel_filter = null;
      this.form.standard_price = this.standard_price;
      this.searchFn().then(() => {
        this.getRecommend().then(() => {
          this.loaddingData();
        });
      });
    },
    date1() {
      this.dateFormatted1 = this.formatDate(this.date1);
      this.form.start_date = this.date1;
    },
    date2() {
      // continue pop up alert date2 > date1
      this.dateFormatted2 = this.formatDate(this.date2);
      this.form.end_date = this.date2;
    },
  },
  created() {
    this.checkDisplay();
    this.checkHightDisplay();
    let date = new Date();
    date.setDate(date.getDate() + 10);
    this.date1 =
      new Date().getFullYear() +
      "-" +
      ((new Date().getMonth() + 1).toString().length === 1
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate().toString().length === 1
        ? "0" + new Date().getDate()
        : new Date().getDate());

    this.dateFormatted1 = this.formatDate(this.date1);
    this.date2 =
      date.getFullYear() +
      "-" +
      ((date.getMonth() + 1).toString().length === 1
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate().toString().length === 1
        ? "0" + date.getDate()
        : date.getDate());
    this.form.start_date = this.date1;
    this.form.end_date = this.date2;
    this.dateFormatted2 = this.formatDate(this.date2);
    this.getIPAddress().then(() => {
      this.getProvinces().then(() => {
        this.getJobtype().then(() => {
          this.getDateSearch();
          this.searchFn().then(() => {
            this.getRecommend().then(() => {
              this.loaddingPage();
              this.loaddingData();
            });
          });
        });
      });
    });
  },

  methods: {
    clearKeyboard() {
      this.$refs.keyboard.focus();
    },
    getIPAddress() {
      return this.$axios
        .get("https://api.db-ip.com/v2/free/self")
        .then((res) => {
          if (res.data.ipAddress !== undefined || res.data.ipAddress !== null) {
            this.form.ipaddress = res.data.ipAddress;
          } else {
            location.reload();
          }
        });
    },
    openFullData(url, code) {
      window.open(url, "_blank");
      this.$axios
        .post(this.api + "/add/viewer", { project_code: code })
        .then(() => {});
      let index = this.datalists.findIndex((x) => x.project_code === code);
      this.datalists[index].viewer += 1;
      this.getRecommend();
    },
    changePage() {
      this.panel = null;
      this.panel_filter = null;
      this.isLoaddingData = true;
      this.searchFn().then(() => {
        this.loaddingData();
        this.$vuetify.goTo(0);
      });
    },
    searchFn(click) {
      if (click) {
        this.form.click = true;
        this.isLoaddingData = true;
        this.form.page = 1;
        this.panel = null;
        this.panel_filter = null;
        this.loaddingData();
        this.$axios.get("https://api.db-ip.com/v2/free/self").then((res) => {
          if (
            res.data.ipAddress === undefined ||
            res.data.ipAddress === null ||
            res.data.ipAddress === ""
          ) {
            location.reload();
          } else {
             let ip = res.data.ipAddress;
             if("110.77.145.181" !== ip && "183.88.221.160" !== ip && "110.77.145.175" !== ip){
               this.$axios
              .post("https://ipapi.co/" + ip + "/json/")
              .then((ress) => {
                let notify = ress.data.country_name + "| IP: " + ip + ")";
                this.$axios.post(this.api + "/notifyLogin", {
                  username: notify,
                  login_type: "AccessWebKanpramool",
                });
              })
              .then(() => {});
             }
          }
        });
      } else {
        this.form.click = false;
      }
      this.$session.set("objSearch", this.form);
      return this.$axios.post(this.api + "/search", this.form).then((res) => {
        if (res.data.status) {
          if (res.data.page === 0) {
            this.no_data = true;
          } else {
            this.pages = res.data.page;
            this.datalists = res.data.response;
            this.no_data = false;
          }
        }
      });
    },
    loaddingData() {
      setTimeout(() => (this.isLoaddingData = false), 1000);
    },
    getRecommend() {
      return this.$axios
        .get(this.api + "/get/recommend/project")
        .then((res) => {
          if (res.data.status) {
            this.datalists_recommend = res.data.response;
          } else {
            console.log("ไม่สามารถเรียกโครงการเเนะนำได้");
          }
        });
    },
    getDateSearch() {
      if (this.$session.get("objSearch") === undefined) {
        this.form.submission_date = "DESC";
        this.form.standard_price = "DESC";
        let date = new Date();
        date.setDate(date.getDate() + 10);
        this.form.start_date =
          new Date().getFullYear() +
          "-" +
          ((new Date().getMonth() + 1).toString().length === 1
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate().toString().length === 1
            ? "0" + new Date().getDate()
            : new Date().getDate());
        this.form.end_date =
          date.getFullYear() +
          "-" +
          ((date.getMonth() + 1).toString().length === 1
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) +
          "-" +
          (date.getDate().toString().length === 1
            ? "0" + date.getDate()
            : date.getDate());
        this.form.jobtype = "All";
        this.form.province = [];
        this.form.page = 1;
        this.form.announcement_type = "invite";
        this.announcement_type = this.form.announcement_type;
        this.dateFormatted2 = this.formatDate(this.form.end_date);
        this.dateFormatted1 = this.formatDate(this.form.start_date);
      } else {
        this.form.submission_date = "DESC";
        this.form.standard_price = "DESC";
        this.form.click = true;
        this.form.ipaddress = this.$session.get("objSearch").ipaddress;
        this.form.start_date = this.$session.get("objSearch").start_date;
        this.form.end_date = this.$session.get("objSearch").end_date;
        this.form.jobtype = this.$session.get("objSearch").jobtype;
        this.form.province = this.$session.get("objSearch").province;
        this.form.announcement_type = this.$session.get(
          "objSearch"
        ).announcement_type;
        this.announcement_type = this.form.announcement_type;
        this.dateFormatted2 = this.formatDate(this.form.end_date);
        this.dateFormatted1 = this.formatDate(this.form.start_date);
        this.form.page = this.$session.get("objSearch").page;
      }
    },
    formatDate(date) {
      if (!date) {
        return null;
      } else {
        let [year, month, day] = date.split("-");
        return `   ${day}   ${month
          .replace(/12/g, "ธ.ค.")
          .replace(/11/g, "พ.ย.")
          .replace(/10/g, "ต.ค.")
          .replace(/09/g, "ก.ย.")
          .replace(/08/g, "ส.ค.")
          .replace(/07/g, "ก.ค.")
          .replace(/06/g, "ม.ย.")
          .replace(/05/g, "พ.ค.")
          .replace(/04/g, "เม.ย.")
          .replace(/03/g, "มี.ค.")
          .replace(/02/g, "ก.พ.")
          .replace(/01/g, "ม.ค.")} ${parseInt(year) + 543}`;
      }
    },
    getProvinces() {
      return this.$axios.get(this.api + "/all/province").then((res) => {
        if (res.data.status) {
          for (let index = 0; index < res.data.response.length; index++) {
            if (index === 0) {
              this.provinces.push(JSON.parse('{"header": "ภาคใต้"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 14) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคตะวันออก"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 21) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคตะวันตก"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 26) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(
                JSON.parse('{"header": "ภาคตะวันออกเฉียงเหนือ"}')
              );
              this.provinces.push(res.data.response[index]);
            } else if (index === 46) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคกลาง"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 68) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคเหนือ"}'));
              this.provinces.push(res.data.response[index]);
            } else {
              this.provinces.push(res.data.response[index]);
            }
          }
        } else {
          console.log("ไม่สามารถเรียกข้อมูลจังหวัดได้");
        }
      });
    },
    loaddingPage() {
      setTimeout(() => (this.isLoadding = !this.isLoadding), 1000);
    },
    getJobtype() {
      return this.$axios.get(this.api + "/all/typejob").then((res) => {
        if (res.data.status) {
          this.jobtypes = res.data.response;
          this.jobtypes.unshift(
            JSON.parse(
              '{"job_type_id": "All", "job_type_name": "งานรับเหมาก่อสร้างทั้งหมด"}'
            )
          );
        } else {
          console.log("ไม่สามารถเรียกข้อมูลประเภทงานได้");
        }
      });
    },
    isFacebookApp() {
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
    },
    checkDisplay() {
      const ua = navigator.userAgent;
      if (
        /(tablet|ipad|playbook|silk|macintosh)|(android(?!.*mobi))/i.test(ua)
      ) {
        if (this.isFacebookApp()) {
          this.display = "Mobile";
        } else {
          this.display = "Tablet";
        }
      } else if (
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        this.display = "Mobile";
      } else {
        this.display = "Desktop";
      }
    },
    checkHightDisplay() {
      this.heightDisplay = screen.height;
    },
    removeProvince(item) {
      let index = this.form.province.indexOf(item.id);
      if (index >= 0) this.form.province.splice(index, 1);
    },
  },
};
</script>

<style>
.listcard-page .v-label {
  color: #4ba0b2 !important;
}
.listcard-page .v-select__selection {
  color: #4347b3 !important;
  font-weight: bold !important;
}
.listcard-page input {
  color: #4347b3 !important;
  font-weight: bold !important;
}
.listcard-page .mdi-calendar {
  color: #4ba0b2 !important;
}
.listcard-page .mdi-menu-down {
  color: #4347b3 !important;
}
.listcard-page .mdi-magnify {
  color: #4ba0b2 !important;
}
.listcard-page .mdi-close {
  color: #4ba0b2 !important;
}
.listcard-page .tab-top {
  border-radius: 0px !important;
}
.listcard-page .switch_content {
  margin: 0px !important;
}
</style>
